import React from 'react';
import { motion } from 'framer-motion';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hoverEffect?: boolean;
}
export function Card({
  children,
  className = '',
  hoverEffect = true
}: CardProps) {
  return <motion.div className={`bg-white rounded-xl border border-gray-100 shadow-sm p-6 ${className}`} whileHover={hoverEffect ? {
    y: -5,
    boxShadow: '0 10px 30px -10px rgba(0,0,0,0.1)'
  } : {}} transition={{
    duration: 0.2
  }} data-id="element-384">
      {children}
    </motion.div>;
}